import {logger} from '@/utilities/logger';

export const handleError = (error: unknown) => {
  logger.break();

  if (typeof error === 'string') {
    logger.error(error);
  } else if (error instanceof Error) {
    logger.error(error.message);
  } else {
    logger.error('Something went wrong. Please try again.');
  }

  logger.break();
  process.exit(1);
};

export default {
  handleError,
};
